import moment from 'moment';
import db from '@/store/db';
import log from '@/logger';
import constants from '@/constants';

export default {
  prepareInspectionEntity: (values) => {
    const inspection = {
      type: 'Inspection',
      projectId: '',
      partId: '',
      title: 'New Inspection',
      inspectionTemplateId: '',
      beginTime: '',
      endTime: '',
      participants: [],
      archived: false,
      currentStage: constants.inspectionStages.init,
      lastUpdate: {},
      ...(values || {}),
    };

    if (!inspection.createdAt) {
      inspection.createdAt = moment().utc().format();
    }

    return inspection;
  },

  async createInspection(values) {
    const inspection = this.prepareInspectionEntity(values);
    return this.saveInspection(inspection);
  },

  async saveInspection(inspection, reason) {
    const isUpdate = !!inspection._id;
    const method = isUpdate ? db.currentProjectDb.put : db.currentProjectDb.post;
    const response = await method(inspection, reason);

    return isUpdate ? { ...inspection, _rev: response.rev } : { ...inspection, _id: response.id, _rev: response.rev };
  },

  async saveInspections(inspections) {
    return db.currentProjectDb.bulkDocs(inspections);
  },

  async getInspection(id) {
    if (!db.currentProjectDb.get) {
      return;
    }

    try {
      const doc = await db.currentProjectDb.get(id);
      return this.prepareInspectionEntity(doc);
    } catch (error) {
      log.error('Unable to load inspection', error);
      throw error;
    }
  },

  async fetchInspectionPdfUrl({ token, locale }) {
    const url = new URL('inspection/report', constants.db.serverUrl.replace('/db', '/inspection/api'));
    url.searchParams.append('token', token);
    url.searchParams.append('locale', locale);

    const response = await fetch(url.toString(), { method: 'GET' });
    if (!response.ok) {
      throw new Error('inspectionApi: Failed to retrieve URL to download PDF');
    }

    return response.json();
  },
};



// WEBPACK FOOTER //
// ./src/store/inspection/inspectionApi.js